import { UIState } from './types';
import * as constants from './constants';

/* eslint-disable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
const initialState: UIState = {
  isLoading: false,
  isInlineResultsLoading: false,
  isShowBottomBar: false,
  loading: {
    button: false,
    general: false,
    productRow: false,
    productDetails: false,
    popupCalendar: false,
    productList: false,
    productEditModal: false,
  },
};

export const UiReducer = (state: UIState = initialState, action: any) => {
  switch (action.type) {
    case constants.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };

    case constants.SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]: action.payload.value,
        },
      };

    case constants.SET_IS_RESULTS_LOADING:
      return {
        ...state,
        isInlineResultsLoading: action.payload.isInlineResultsLoading,
      };
    case constants.SET_IS_SHOW_BOTTOM_BAR:
      return {
        ...state,
        isShowBottomBar: action.payload.isShowBottomBar,
      };
    case constants.SET_IS_BATCH_SELECT:
      return {
        ...state,
        isBatchSelect: action.payload.isBatchSelect,
      };
    default:
      return state;
  }
};
